import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Switch } from '../../../2-component';
import { FormModal } from '../../../3-pattern';
import { Box } from '../../../1-primative';

export type WorkflowSettings = {
  displayCloseButton: boolean
  cancelOnClose: boolean
  archiveObjectsOnClose: boolean
};
export const SettingsModal = (props: {
  workflowSettings: WorkflowSettings,
  onSubmit: (settings: WorkflowSettings) => any,
  onClose: () => any,
  loading: boolean,
  open: boolean,
}) => {
  const {
    workflowSettings,
    onClose,
    onSubmit,
    loading,
    open,
  } = props;

  const { t } = useTranslation('workflowCompletions');

  const [displayCloseButtonState, setDisplayCloseButtonState] = useState(workflowSettings.displayCloseButton);
  const [cancelOnCloseState, setCancelOnCloseState] = useState(workflowSettings.cancelOnClose);
  const [archiveObjectsOnCloseState, setArchiveObjectsOnCloseState] = useState(workflowSettings.archiveObjectsOnClose);

  useEffect(() => {
    if (open) {
      setDisplayCloseButtonState(workflowSettings.displayCloseButton);
      setCancelOnCloseState(workflowSettings.cancelOnClose);
      setArchiveObjectsOnCloseState(workflowSettings.archiveObjectsOnClose);
    }
  }, [open, workflowSettings]);

  return (
    <FormModal
      testId='settings-modal'
      title={t('settingsModal.title')}
      formButton={t('settingsModal.saveButton')}
      handleClose={onClose}
      onSubmit={() => onSubmit({
        displayCloseButton: displayCloseButtonState,
        cancelOnClose: cancelOnCloseState,
        archiveObjectsOnClose: archiveObjectsOnCloseState,
      })}
      loading={loading}
      open={open}
    >
      <Box display='flex' flexDirection='column' gap={2}>
        <Switch
          testId='settings-modal-display-close-button'
          disabled={loading}
          checked={displayCloseButtonState}
          onChange={(checked) => setDisplayCloseButtonState(checked)}
          label={t('settingsModal.displayCloseButton')}
        />
        {displayCloseButtonState && (
          <Switch
            testId='settings-modal-cancel-on-close'
            disabled={loading}
            checked={cancelOnCloseState}
            onChange={(checked) => setCancelOnCloseState(checked)}
            label={t('settingsModal.cancelOnClose')}
          />
        )}
        <Switch
          testId='settings-modal-archive-objects-on-close'
          disabled={loading}
          checked={archiveObjectsOnCloseState}
          onChange={(checked) => setArchiveObjectsOnCloseState(checked)}
          label={t('settingsModal.archiveObjectsOnClose.0')}
          infoTooltip={t('settingsModal.archiveObjectsOnClose.1')}
        />
      </Box>
    </FormModal>
  );
};
